import { render, staticRenderFns } from "./pendClient.vue?vue&type=template&id=23e3c311&scoped=true"
import script from "./pendClient.vue?vue&type=script&lang=js"
export * from "./pendClient.vue?vue&type=script&lang=js"
import style0 from "./pendClient.vue?vue&type=style&index=0&id=23e3c311&prod&scoped=true&lang=less"
import style1 from "./pendClient.vue?vue&type=style&index=1&id=23e3c311&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e3c311",
  null
  
)

export default component.exports